import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import getId from '@clearscore/helpers.uid';

const getConfig = (state) => resolveProp('identity.config', state);

export default createSelector(getConfig, (config) => {
    if (config) {
        const { issuer, responseMode, clientId, redirectUri, responseType, scope } = config;
        if (issuer && responseMode && clientId && redirectUri && responseType && scope) {
            // eslint-disable-next-line max-len
            return `${issuer}/v1/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&state=${getId()}&nonce=${getId()}&response_mode=${encodeURIComponent(
                responseMode,
            )}&response_type=${encodeURIComponent(responseType)}&scope=${encodeURIComponent(scope)}`;
        }
    }
    return null;
});
